"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { localizePath, splitLocale, type Locale } from "../lib/i18n/config";
import { useLocale } from "./LocaleProvider";

const LABELS: Record<Locale, { short: string; name: string }> = {
  en: { short: "EN", name: "English" },
  ro: { short: "RO", name: "Română" },
};

export default function LanguageSwitcher({ className = "" }: { className?: string }) {
  const locale = useLocale();
  const pathname = usePathname() || "/";
  const { path } = splitLocale(pathname);

  return (
    <div
      className={`inline-flex items-center rounded-full border border-white/15 p-0.5 text-xs font-semibold ${className}`}
      role="group"
      aria-label="Language"
    >
      {(Object.keys(LABELS) as Locale[]).map((l) => {
        const active = l === locale;
        return (
          <Link
            key={l}
            href={localizePath(l, path)}
            hrefLang={l}
            lang={l}
            title={LABELS[l].name}
            aria-current={active ? "true" : undefined}
            className={`rounded-full px-2.5 py-1 transition ${
              active ? "bg-[#27E8A7] text-black" : "text-white/80 hover:text-white"
            }`}
          >
            {LABELS[l].short}
          </Link>
        );
      })}
    </div>
  );
}
